import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector: 'app-firmware-update-dialog',
    templateUrl: './firmware-update-dialog.component.html',
    styleUrls: ['./firmware-update-dialog.component.scss']
})
export class FirmwareUpdateDialogComponent {
    dontShowAgain = false;

    constructor(private dialogRef: MatDialogRef<FirmwareUpdateDialogComponent>) {}

    close() {
        this.dialogRef.close(this.dontShowAgain);
    }
}
